import React, { SVGProps } from 'react';

import { withCustomIcon } from './withCustomIcon';

const MailIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_90_363)">
                <path d="M21 1.00031H3C2.20435 1.00031 1.44129 1.31638 0.87868 1.87898C0.31607 2.44159 0 3.20466 0 4.00031L0 23.0003H24V4.00031C24 3.20466 23.6839 2.44159 23.1213 1.87898C22.5587 1.31638 21.7956 1.00031 21 1.00031ZM3 3.00031H21C21.2652 3.00031 21.5196 3.10566 21.7071 3.2932C21.8946 3.48073 22 3.73509 22 4.00031V4.6673L14.122 12.5463C13.5584 13.1076 12.7954 13.4228 12 13.4228C11.2046 13.4228 10.4416 13.1076 9.878 12.5463L2 4.6673V4.00031C2 3.73509 2.10536 3.48073 2.29289 3.2932C2.48043 3.10566 2.73478 3.00031 3 3.00031ZM2 21.0003V7.50031L8.464 13.9603C9.40263 14.8966 10.6743 15.4223 12 15.4223C13.3257 15.4223 14.5974 14.8966 15.536 13.9603L22 7.50031V21.0003H2Z" fill="#374957" />
            </g>
            <defs>
                <clipPath id="clip0_90_363">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default withCustomIcon(MailIcon);